// :cow: Cosmose CONFIDENTIAL :iso:
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { State, STATE_NAME } from './dashboard-groups.reducer';

const currentState = createFeatureSelector<State>(STATE_NAME);

export const selectGroupsResponse = createSelector(
  currentState,
  (state: State) => state.customGroupsResponse?.content,
);

export const selectShowSkeleton = createSelector(
  currentState,
  (state: State) => state.isLoading,
);

export const selectShowError = createSelector(
  currentState,
  (state: State) => state.isError,
);

export const selectShowSection = createSelector(
  currentState,
  (state: State) => state.isLoading || state.customGroupsResponse?.content?.length > 0,
);

export const selectShowShowAll = createSelector(
  currentState,
  (state: State) => state.customGroupsResponse?.totalPages > 1,
);

export const selectShowList = createSelector(
  currentState,
  (state: State) => state.customGroupsResponse?.content?.length > 0,
);

export const selectShowEmpty = createSelector(
  currentState,
  (state: State) => state.customGroupsResponse?.empty,
);
